define('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemHourView',['require','lib/view/CompositeView','lib/Utils','view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemHourItemView','lib/view/UnwrapBehavior'],function (require) {

    var CompositeView = require('lib/view/CompositeView');
    var Utils = require('lib/Utils');
    var TimeFlexibleProviderItemHourItemView = require('view/controller/booking/datetime/flexible-provider/TimeFlexibleProviderItemHourItemView');
    var UnwrapBehavior = require('lib/view/UnwrapBehavior');

    return CompositeView.extend({

        template: '#time_flexible_provider_item_hour_view',
        childView: TimeFlexibleProviderItemHourItemView,
        childViewContainer: '.sb_time_flexible_hour_container',

        behaviors: {
            UnwrapBehavior: {
                behaviorClass: UnwrapBehavior
            }
        },

        childViewOptions: function (model, index) {
            return {
                clientTimeZone: this.getOption('clientTimeZone'),
                provider: this.getOption('provider')
            };
        },

        initialize: function () {
            this.collection = this.model.get('collection');
        },

        serializeData: function () {
            var result = CompositeView.prototype.serializeData.apply(this);
            result.time_diff = Utils.timeDiff(result, this.getOption('clientTimeZone'));

            return result;
        },

        onChildviewHoverTime: function (view, data) {
            if (data.model.get('type') === 'free') {
                this.triggerMethod('hover:time', data);
            }
        },

        onChildviewSelectTime: function (view, data) {
            if (data.model.get('type') === 'free') {
                this.triggerMethod('select:time', data);
            }
        }

    });

});

